import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_label_list_hdr_RowClass} from '../../../dbschema/bl_fi_mst_label_list_hdr.model';

export class LabelListContainerModel extends BaseContainerModel {
  bl_fi_mst_label_list_hdr: bl_fi_mst_label_list_hdr_RowClass = new bl_fi_mst_label_list_hdr_RowClass();
}
